import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useState } from 'react';
import { i18n } from '../../../utils/i18n.js';
import { Popover, Tooltip, BadgeAnchor, Divider } from '@tecsinapse/cortex-react';
import { FiAlertCircle } from 'react-icons/fi';
import { LuBell } from 'react-icons/lu';
import { Footer } from '../components/footer.js';
import { Header } from '../components/header.js';
import { Item } from '../components/item.js';

const NotificationList = (props) => {
  const {
    notificationCount,
    notifications,
    showNotifications,
    linkPortal,
    onCloseNotifications
  } = props;
  const [notificationsList, setNotificationsList] = useState(Array.isArray(notifications) ? notifications : []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setError(null);
      if (typeof notifications === "function") {
        const result = await notifications();
        if (result?.data?.notificacoesMenu) {
          setNotificationsList(result.data.notificacoesMenu);
        } else {
          setNotificationsList([]);
        }
      }
    } catch (err) {
      setError(err);
      console.error("Error loading notifications:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleBellClick = () => {
    if (typeof notifications === "function") {
      fetchNotifications().then();
    }
  };
  const recentNotifications = notificationsList.filter((notification) => notification.recente);
  const previousNotifications = notificationsList.filter((notification) => !notification.recente);
  if (!showNotifications) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Popover.Root, { trigger: "click", children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, { text: i18n._(
      /*i18n*/
      {
        id: "sZjLlB"
      }
    ), children: /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, { text: i18n._(
      /*i18n*/
      {
        id: "sZjLlB"
      }
    ), children: /* @__PURE__ */ jsx("div", { onClick: handleBellClick, children: notificationCount > 0 ? /* @__PURE__ */ jsx(BadgeAnchor, { value: notificationCount, variants: {
      intent: "error",
      isAnchor: true
    }, children: /* @__PURE__ */ jsx(LuBell, { className: "text-secondary-medium hover:cursor-pointer", size: 24 }) }) : /* @__PURE__ */ jsx(LuBell, { className: "text-secondary-medium hover:cursor-pointer", size: 24 }) }) }) }) }) }),
    /* @__PURE__ */ jsxs(Popover.Content, { className: "bg-white", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex bg-white flex-col w-[420px] h-[50vh]", children: [
        loading ? /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center p-mili h-full", children: /* @__PURE__ */ jsx("p", { className: "font-bold text-primary-medium", children: i18n._(
          /*i18n*/
          {
            id: "tWILls"
          }
        ) }) }) : error ? /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center p-mili h-full", children: /* @__PURE__ */ jsx("p", { className: "text-error-medium font-bold", children: i18n._(
          /*i18n*/
          {
            id: "s1Qipq"
          }
        ) }) }) : notificationsList.length === 0 ? /* @__PURE__ */ jsxs("div", { className: "flex bg-white flex-col w-[420px]", children: [
          /* @__PURE__ */ jsx(Header, { title: "Notificações" }),
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center items-center p-mili", children: [
            /* @__PURE__ */ jsx(FiAlertCircle, { size: 24, className: "text-primary-medium" }),
            /* @__PURE__ */ jsx("p", { className: "font-bold text-h4 text-primary-medium", children: i18n._(
              /*i18n*/
              {
                id: "Gds+GM"
              }
            ) }),
            /* @__PURE__ */ jsx("p", { children: i18n._(
              /*i18n*/
              {
                id: "TcARn6"
              }
            ) })
          ] })
        ] }) : null,
        recentNotifications.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Header, { title: i18n._(
            /*i18n*/
            {
              id: "Gdt21R"
            }
          ) }),
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx("div", { className: "overflow-y-scroll", children: recentNotifications.map((notification) => /* @__PURE__ */ jsx(Item, { notification }, notification.id)) })
        ] }) : null,
        previousNotifications.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Header, { title: i18n._(
            /*i18n*/
            {
              id: "SMpzCG"
            }
          ) }),
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx("div", { className: "overflow-y-scroll", children: previousNotifications.map((notification) => /* @__PURE__ */ jsx(Item, { notification }, notification.id)) })
        ] }) : null
      ] }),
      /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsx(Footer, { linkPortal, onCloseNotifications })
    ] })
  ] });
};

export { NotificationList };
